import moment from "moment";
moment.locale("pt");
export default {
  install: (Vue: any) => {
    Vue.prototype.$moment = moment;

    // 4. adicionar um método de instância
  },
};
